import { render } from "./back.vue?vue&type=template&id=1aeae7d7&scoped=true"
import script from "./back.vue?vue&type=script&lang=js"
export * from "./back.vue?vue&type=script&lang=js"

import "./back.vue?vue&type=style&index=0&id=1aeae7d7&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1aeae7d7"]])

export default __exports__